import { useMemo } from 'react';
import {
  IBuilderCohortOperator,
  setCohortRowOperator,
  setCohortRowTimeToConvertOperator,
} from '../../../../../redux/slices/oldBuilder';
import { SingleSelectMenu } from '../../../../Dropdown';
import {
  useCohortRowContext,
  useCohortRowOperatorAndValues,
} from '../CohortRowContext';
import { useAppDispatch } from '../../../../../redux/hooks';
import { TimeToConvertOperatorKey } from '../../../../../utils/apollo/graphqlSchema';

interface IProps {
  operators: IBuilderCohortOperator[];
}

const CohortRowOperatorMenu = ({ operators }: IProps) => {
  const dispatch = useAppDispatch();
  const { rowMeta, cohortRow, isTimeToConvertRow } = useCohortRowContext();
  const { simpleCohortTypeKey } = cohortRow;
  const { operator } = useCohortRowOperatorAndValues();
  const handleChange = (newOperator: string) => {
    if (isTimeToConvertRow) {
      dispatch(
        setCohortRowTimeToConvertOperator({
          newValue: newOperator as TimeToConvertOperatorKey,
          rowMeta,
        }),
      );
    } else {
      dispatch(
        setCohortRowOperator({
          value: newOperator,
          rowMeta,
          simpleCohortTypeKey,
        }),
      );
    }
  };

  const options = useMemo(
    () =>
      operators.map((operator) => ({
        text: operator.name,
        value: operator.key,
      })),
    [operators],
  );

  return (
    <SingleSelectMenu
      options={options}
      value={operator}
      onChange={handleChange}
    />
  );
};

export default CohortRowOperatorMenu;
